import { useState, useEffect, useCallback } from 'react';
import { userStorage } from '../lib/storage';

const STORAGE_KEY = 'sp_favorites';

function loadFavorites(): Set<string> {
  try {
    const ids = userStorage.get<string[]>(STORAGE_KEY);
    if (ids) return new Set(ids);
  } catch { /* ignore */ }
  return new Set();
}

function saveFavorites(ids: Set<string>) {
  userStorage.set(STORAGE_KEY, [...ids]);
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<Set<string>>(() => loadFavorites());

  // Persist on change
  useEffect(() => {
    saveFavorites(favorites);
  }, [favorites]);

  const toggleFavorite = useCallback((propertyId: string) => {
    setFavorites(prev => {
      const next = new Set(prev);
      if (next.has(propertyId)) {
        next.delete(propertyId);
      } else {
        next.add(propertyId);
      }
      return next;
    });
  }, []);

  const isFavorite = useCallback((propertyId: string) => {
    return favorites.has(propertyId);
  }, [favorites]);

  const clearFavorites = useCallback(() => {
    setFavorites(new Set());
  }, []);

  return {
    favorites,
    favoriteCount: favorites.size,
    toggleFavorite,
    isFavorite,
    clearFavorites,
  };
}
